import styled, { css } from "styled-components";

interface IlineTableProps {
  active: boolean;
}

export const Container = styled.div`
  width: 100%;
`;

export const RowEdit = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;

  svg + svg {
    margin-left: 20px;
  }
`;

export const Line1 = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  width: 100%;
  margin-bottom: 10px;
  row-gap: 10px;
  column-gap: 10px;
`;

export const Line2 = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr 100px;
  width: 100%;
  margin-bottom: 10px;
  column-gap: 10px;
`;

export const FormItem = styled.div`
  /* margin: 5px; */
`;

export const SearchRow = styled.div`
  padding: 20px;
`;

export const LineTable = styled.tr<IlineTableProps>`
  background-color: #fff;

  ${(props) =>
    props.active &&
    css`
      background-color: var(--grey);
    `}
`;

export const CellLine = styled.td`
  background-color: inherit !important;
`;

export const LineNewAddress = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 20px;
`;

export const AlignButtonSearch = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: end;
`;

export const TableContent = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  padding: 20px;
`;
